import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-rp-bg">
        <div className="text-rp-textDim font-mono text-xs tracking-[0.2em] uppercase">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login?next=/admin" replace />;
  if (!user.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
}
